import React from "react";
import "../index.css";

function LoadingSpinner({
  text = "Loading...",
  fullPage = false,
  size = 72,
  transparent = false,
}) {
  return (
    <div
      className={fullPage ? "loading-screen" : "loading-inline"}
      style={{
        "--spinner-size": `${size}px`,

        ...(transparent
          ? {
              background: "transparent",
              backgroundColor: "transparent",
              boxShadow: "none",
              border: "none",
              backdropFilter: "none",
              WebkitBackdropFilter: "none",
            }
          : {}),
      }}
    >
      <div
        className="loading-spinner-wrap"
        style={
          transparent
            ? {
                background: "transparent",
                backgroundColor: "transparent",
                boxShadow: "none",
                border: "none",
                backdropFilter: "none",
                WebkitBackdropFilter: "none",
                padding: 0,
              }
            : undefined
        }
      >
        <div className="loading-spinner">
          <div className="loading-spinner-ring" />
          <div className="loading-spinner-core" />
        </div>

        {text ? <div className="loading-spinner-text">{text}</div> : null}
      </div>
    </div>
  );
}

export default LoadingSpinner;